<template>
  <v-card
    :id="indexKey"
    :ref="indexKey"
    color="#e6f9ec"
    elevation="2"
    outlined
  >
    <v-row v-if="loading">
      <v-skeleton-loader
        class="mx-auto mb-3"
        min-width="100%"
        type="card"
      />
    </v-row>
    <template v-else>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            md="8"
            class="d-flex align-center gap5"
          >
            <span class="color-icon">🛣️</span>
            <div class="title-status">
              <span class="title"> {{ items.route_name }} </span>
              <!-- <v-icon>mdi-arrow-right</v-icon>
              <span class="title"> </span> -->
              <!-- {{ tripTo || "-" }} -->
              <span>
                Vehicle Registration: <b>{{ items.reg_no }}</b>
              </span>
              <div>
                <v-chip
                  small
                  color="green"
                  outlined
                >
                  <StatusBadge :status="'completed'" />
                  {{ "Completed" }}
                </v-chip>
              </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="d-flex justify-end align-center"
          >
            <span
              class="color-icon"
              style="cursor: pointer"
              @click="$emit('toggle')"
            >
              <!-- @click="onCollapse" -->
              {{ isOpen ? "🔼" : "🔽" }}
            </span>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col
            v-for="(r, i) in cards"
            :key="i"
            cols="12"
            sm="2"
          >
            <v-card
              class="pa-3"
              outlined
              tile
            >
              <div class="d-flex align-center">
                <v-icon :color="r.iconColor">
                  {{ r.icon }}
                </v-icon>
                <div class="ml-2">
                  <div class="caption text--secondary">
                    {{ r.label }}
                  </div>
                  <div class="font-weight-bold">
                    <template v-if="r.format">
                      {{ r.value | formatDate }}
                    </template>
                    <template v-else>
                      {{ r.value }}
                    </template>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!-- section -->
        <template v-if="isOpen">
          <div
            v-if="isDetail"
            class="loader"
          >
            <v-skeleton-loader
              class="mx-auto mb-3"
              min-width="100%"
              type="table"
            />
          </div>
          <template v-else>
            <div class="d-flex justify-end">
              <DownloadFileButtons
                :loading="isDownload"
                large
                :items="['csv', 'pdf']"
                @click="downloadFile"
              />
            </div>

            <v-row>
              <v-col cols="12">
                <v-card class="mt-4">
                  <v-card-title>
                    <div class="data-table-heading">
                      Trips Breakdown
                    </div>
                  </v-card-title>
                  <v-data-table
                    :headers="header"
                    :items="details"
                    :items-per-page="10000"
                    hide-default-footer
                  >
                    <template v-slot:[`item.trip_id`]="{ index }">
                      <div>
                        {{ index + 1 }}
                      </div>
                    </template>
                    <template v-slot:[`item.event_start`]="{ item, index }">
                      <div>
                        <div
                          class="open-link"
                          @click="openModal('start', item, index)"
                        >
                          {{ item?.start_city || "-" }}
                        </div>
                        <div>
                          🕒 {{ item.event_start?.split("+")[0] | formatDate }}
                        </div>
                      </div>
                    </template>
                    <template v-slot:[`item.event_end`]="{ item, index }">
                      <div>
                        <div
                          class="open-link"
                          @click="openModal('end', item, index)"
                        >
                          {{ item?.end_city || "-" }}
                        </div>
                        <div>
                          🕒{{ item.event_end?.split("+")[0] | formatDate }}
                        </div>
                      </div>
                    </template>

                    <template v-slot:[`item.distance_km`]="{ item }">
                      <div>{{ item.distance_km }} km</div>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <!-- 
          
          -->
        </template>
      </v-card-text>
    </template>
    <VehiclePositionModal
      v-if="isModal"
      :is-visible-dialog="isModal"
      :position="selectedPoints"
      :show-geofence="showGeofence"
      :toggle-modal="toggleModal"
      :geofence="selectedGeofence"
    />
  </v-card>
</template>
<script>
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { mapGetters } from "vuex";
// import { nextTick } from "vue";
export default {
  components: {
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
    DownloadFileButtons: () =>
      import("@/components/base/DownloadFileButtons.vue"),
    VehiclePositionModal: () =>
      import("@/components/sections/VehiclePositionModal.vue"),
  },
  props: {
    indexKey: {
      type: String,
      default() {
        return "abc-000";
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    items: {
      type: Object,
      default() {
        return {};
      },
    },
    //geofence: {
    // type: Object,
    // default() {
    //  return {};
    // },
    // },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // isCollapse: false,
      isDownload: false,
      pdfLogo: require("@/assets/brandLogo/pdfLogo.png"),

      header: [
        {
          //   text: this.$t("registration_no"),
          text: "🚗 Trip #",
          align: "left",
          sortable: false,
          value: "trip_id",
        },
        {
          //   text: this.$t("registration_no"),
          text: "📍 Start",
          align: "left",
          sortable: false,
          value: "event_start",
        },
        {
          //   text: this.$t("registration_no"),
          text: "🛑 Stop",
          align: "left",
          sortable: false,
          value: "event_end",
        },
        {
          //   text: this.$t("registration_no"),
          text: "🧭 Distance",
          align: "left",
          sortable: false,
          value: "distance_km",
        },
        {
          //   text: this.$t("registration_no"),
          text: "⚡ Fuel",
          align: "left",
          sortable: false,
          value: "fuel",
        },
        {
          //   text: this.$t("registration_no"),
          text: "⏱️ Idle",
          align: "left",
          sortable: false,
          value: "idle_duration_formatted",
        },
        {
          //   text: this.$t("registration_no"),
          text: "👤 Driver",
          align: "left",
          sortable: false,
          value: "driver_name",
        },
        // {
        //   //   text: this.$t("registration_no"),
        //   text: "🔗 Map",
        //   align: "left",
        //   sortable: false,
        //   value: "map",
        // },
      ],

      //
      isModal: false,
      selectedPoints: {},
      selectedIndex: 0,
      showGeofence: false,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isDetail: "transitReports/getIsDetail",
      details: "transitReports/getDetails",
    }),
    cards() {
      const arr = this.items;
      return [
        {
          icon: "mdi-sort-clock-descending",
          iconColor: "green",
          label: "Departure Time",
          value: arr?.trip_start,
          format: true,
        },
        {
          icon: "mdi-sort-clock-ascending",
          iconColor: "green",
          label: "Arrival Time",
          value: arr?.trip_end,
          format: true,
        },

        {
          icon: "mdi-clock-outline",
          iconColor: "grey",
          label: "Total Duration",
          value: arr?.formatted_total_duration,
        },
        {
          icon: "mdi-timer-sand",
          iconColor: "orange",
          label: "Total Distance",
          value: `${arr?.total_distance} km`,
        },
        {
          icon: "mdi-flash",
          iconColor: "yellow darken-2",
          label: "Fuel Consumed",
          value: "-",
        },
        {
          icon: "mdi-stop-circle",
          iconColor: "red",
          label: "Total Idle Time",
          value: arr?.formatted_idle_time,
        },
      ];
    },

    fromGeofence() {
      const geo = this.items?.route?.from_geofence;
      if (geo) {
        const params = {
          id: geo.id,

          radius: geo.radius,
          geofence_type: geo.geofence_type,
        };
        if (params.geofence_type == "circle") {
          params.center_point = {
            lat: geo.center_point[0],
            lng: geo.center_point[1],
          };
        } else {
          params.polygon = geo.polygon.map((r) => ({
            lat: r[0],
            lng: r[1],
          }));
        }

        return params;
      } else {
        return {};
      }
    },
    toGeofence() {
      const geo = this.items?.route?.to_geofence;
      if (geo) {
        const params = {
          id: geo.id,

          radius: geo.radius,
          geofence_type: geo.geofence_type,
        };
        if (params.geofence_type == "circle") {
          params.center_point = {
            lat: geo.center_point[0],
            lng: geo.center_point[1],
          };
        } else {
          params.polygon = geo.polygon.map((r) => ({
            lat: r[0],
            lng: r[1],
          }));
        }
        return params;
      } else {
        return {};
      }
    },

    selectedGeofence() {
      if (this.showGeofence) {
        if (this.selectedIndex == 0) {
          return this.fromGeofence;
        } else {
          return this.toGeofence;
        }
      } else {
        return {};
      }
    },
  },
  watch: {
    isOpen: {
      async handler(v) {
        if (v) {
          const params = {
            date: [this.items.trip_start, this.items.trip_end],
            imei: this.items.imei,
            vehicle_id: this.items.vehicle_id,
          };
          await this.$store.dispatch("transitReports/details", params);
          await this.getCityName();
        }
      },
      immediate: false,
    },
  },

  methods: {
    // async onCollapse() {
    //   this.isCollapse = !this.isCollapse;
    //   if (this.isCollapse) {
    //     await this.$store.dispatch("transitReports/details", this.items);
    //     await this.getCityName();
    //   }
    // },
    downloadFile(v) {
      const fileName = "Transit Report";
      if (v === "pdf") {
        this.downloadPDF(fileName);
      } else if (v === "csv") {
        this.downloadCSV(fileName);
      }
    },
    openModal(v, row, i) {
      this.selectedPoints = {};
      this.selectedIndex = i;
      this.showGeofence = i == 0 || i == this.details.length - 1 ? true : false;
      if (v == "start") {
        this.selectedPoints = {
          lat: row?.start_lat,
          lng: row?.start_lon,
        };
        this.toggleModal();
      } else if (v == "end") {
        this.selectedPoints = {
          lat: row?.end_lat,
          lng: row?.end_lon,
        };
        this.toggleModal();
      }
    },
    toggleModal() {
      this.isModal = !this.isModal;
    },
    async downloadPDF(fName = "Transit Report") {
      this.isDownload = true;
      try {
        const el = document.getElementById(this.indexKey);
        const canvas = await html2canvas(el, {
          scale: 1.5,
          useCORS: true,
          logging: false,
        });

        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "px",
          format: "a4",
        });

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const padding = 20;
        const headerHeight = 80;
        const usableHeight = pageHeight - headerHeight;

        const imgWidth = pageWidth - padding * 2;
        const scaleRatio = imgWidth / canvas.width;
        const scaledCanvasHeight = canvas.height * scaleRatio;

        const totalPages = Math.ceil(scaledCanvasHeight / usableHeight);

        for (let i = 0; i < totalPages; i++) {
          if (i > 0) pdf.addPage();

          const pageCanvas = document.createElement("canvas");
          const context = pageCanvas.getContext("2d");

          pageCanvas.width = canvas.width;
          pageCanvas.height = usableHeight / scaleRatio;

          context.fillStyle = "white"; // Optional: Set a background color for JPEG
          context.fillRect(0, 0, pageCanvas.width, pageCanvas.height); // Fill the background with white

          context.drawImage(
            canvas,
            0,
            (usableHeight / scaleRatio) * i,
            canvas.width,
            usableHeight / scaleRatio,
            0,
            0,
            canvas.width,
            usableHeight / scaleRatio
          );

          // const pageImgData = pageCanvas.toDataURL("image/png");
          const pageImgData = pageCanvas.toDataURL("image/jpeg", 0.1); // 70% quality

          if (i === 0) {
            // Only add logo + title on first page
            if (this.authUser.isAdmin) {
              pdf.addImage(this.pdfLogo, "PNG", pageWidth - 70, 20, 50, 30);
            } else {
              const bLogo = this.authUser?.business_logo;
              pdf.addImage(bLogo, "PNG", pageWidth - 70, 20, 50, 50);
            }
            pdf.setFontSize(18);
            pdf.text(fName, 20, 40);
          }

          const yOffset = i === 0 ? headerHeight : 0;
          pdf.addImage(
            pageImgData,
            "JPEG",
            padding,
            yOffset,
            imgWidth,
            usableHeight
          );
        }

        pdf.save(`${fName}.pdf`);
      } catch (err) {
        this.$store.dispatch("alerts/error", this.$t("file_corrupted"));
      } finally {
        this.isDownload = false;
      }
    },

    convertToCSV(head, objArray) {
      const summary = this.cards
        .map((item) => `${item.label},${item.value}`)
        .join("\r\n");
      const summarySection = "Summary Data\r\n" + summary + "\r\n\r\n";

      const escape = (val) => `"${String(val).replace(/"/g, '""')}"`;

      // Insert 'New' column before 'start'
      const modifiedHead = [];
      head.forEach((h) => {
        if (h.value === "event_start") {
          modifiedHead.push({ text: "Start City", value: "start_city" }); // insert before 'start'
        }
        if (h.value === "event_end") {
          modifiedHead.push({ text: "End City", value: "end_city" }); // insert before 'stop'
        }
        modifiedHead.push(h);
      });

      const headerRow = modifiedHead.map((h) => escape(h.text)).join(",");

      const rows = objArray.map((row, index) =>
        modifiedHead
          .map((h) => {
            if (h.value === "trip_id") {
              // Replace trip_id column with 1-based index
              return escape(index + 1);
            } else {
              return escape(row[h.value] ?? "");
            }
          })
          .join(",")
      );

      const tableSection =
        "Trips Breakdown\r\n" + headerRow + "\r\n" + rows.join("\r\n");

      return summarySection + tableSection;
    },
    downloadCSV(fName = "logFile") {
      const csv = this.convertToCSV(this.header, this.details);
      const blob = new Blob(["\uFEFF" + csv], {
        type: "text/csv;charset=utf-8;",
      }); // With BOM
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${fName}.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    //
    async getCityName() {
      const promises = [];
      for (const t of this.details) {
        promises.push(
          this.reverseGeocode(t.start_lat, t.start_lon).then(
            (c) => (t.start_city = c)
          ),
          this.reverseGeocode(t.end_lat, t.end_lon).then(
            (c) => (t.end_city = c)
          )
        );
      }

      await Promise.all(promises);
    },
    async reverseGeocode(lat, lng) {
      const apiKey = process.env.VUE_APP_GOOGLE_MAP_KEY; // 🔐 Replace securely
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

      try {
        const response = await fetch(url);
        const data = await response.json();
        if (data.status === "OK") {
          const result = data.results.find(
            (r) =>
              r.types.includes("locality") ||
              r.types.includes("administrative_area_level_2")
          );
          const cName =
            result?.formatted_address ||
            data.results[0]?.formatted_address ||
            "-";
          return cName.split(",")[0];
        } else {
          return "-";
        }
      } catch (error) {
        return "-";
      }
    },
  },
};
</script>

<style scoped>
.caption {
  font-size: 0.8rem;
}
</style>
<style lang="sass" scoped>
.color-icon
    font-size: 1.5rem

.title
    font-size: 20px !important
    font-weight: 600
    text-transform: capitalize

.title-status
    display: flex
    flex-direction: column
    //align-items: center
    // gap: 0.5rem


.v-card__title
    background: #FFF
    margin: 0.3rem

.v-card__text
    margin-top: 1rem

.data-table-heading
    font-size: 18px
    font-weight: 600




// @media only screen and (max-width: 960px)
//     .title-status
//         display: block
</style>
